import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import musicPlayerStore from "../../zustand/musicPlayer.store";
import songsStore from "../../zustand/songs.store";
import playlistStore from "../../zustand/playlist.store";
import likedSongsStore from "../../zustand/likedSong.store";
import userStore from "../../zustand/user.store";
import { addSongToFavorites, removeSongFromFavorites } from "../../actions/songs.actions";
import { showToaster } from "../../helpers/toaster.helpers";
import { getSongs } from "../../pages/editPlaylistPage/editPlayListPage.helpers";
import MobileSongList from "../components/MobileSongList";
import ThumbNail from "../../components/thumbNail/ThumbNail";
import Icons from "../../components/icons";
import { ICONS } from "../../constants/icons.constants";
import { MEDIA_URL } from "../../axios";
import styles from "./MobileHome.module.scss";
import cx from "classnames";

const SkeletonLoader = () => (
  <div className={styles.loader}>
    <div className={styles.skeletonHero}>
      <div className={cx(styles.skeletonArt, styles.skeleton)} />
      <div className={styles.skeletonHeroText}>
        <div className={cx(styles.skeletonLine, styles.skeleton)} />
        <div className={cx(styles.skeletonLine, styles.skeleton)} />
      </div>
    </div>
    {[...Array(8)].map((_, i) => (
      <div key={i} className={styles.skeletonItem}>
        <div className={cx(styles.skeletonThumb, styles.skeleton)} />
        <div className={styles.skeletonLines}>
          <div className={cx(styles.skeletonLine, styles.skeleton)} />
          <div className={cx(styles.skeletonLine, styles.skeleton)} />
        </div>
      </div>
    ))}
  </div>
);

const MobileHome = () => {
  const {
    currentSongIndex, songs: playerSongs, playList, isPlaying,
    setIsPlaying, setCurrentSongIndex, searchedSong,
  } = musicPlayerStore((state) => state);
  const { playlists } = playlistStore((state) => ({ playlists: state.playlists }));
  const { addSong: addLikedSong, deleteSong: deleteLikedSong } = likedSongsStore();
  const { userOffline } = userStore((state) => ({ userOffline: state.userOffline }));
  const { isLoading } = songsStore();
  const navigate = useNavigate();
  const [currentPlayList, setCurrentPlayList] = useState({});

  useEffect(() => {
    if (playList?.id) setCurrentPlayList(getSongs(playList, playlists));
  }, [playList, playlists]);

  const handleSongClick = (index) => {
    if (window.__4playEngine) window.__4playEngine.primeElements();
    setCurrentSongIndex(index);
    if (!isPlaying) setIsPlaying(true);
  };

  const handleLikeClick = async (song, isAlreadyLiked) => {
    if (userOffline) return showToaster("error", "You are offline");
    const { id, index = "1.0" } = song;
    if (isAlreadyLiked) deleteLikedSong(id); else addLikedSong(id);
    const ok = isAlreadyLiked
      ? await removeSongFromFavorites({ song_id: id })
      : await addSongToFavorites({ song_id: id, index });
    if (!ok) { if (isAlreadyLiked) addLikedSong(id); else deleteLikedSong(id); }
  };

  if (isLoading) {
    return <div className={styles.page}><SkeletonLoader /></div>;
  }

  if (isEmpty(playerSongs)) {
    return (
      <div className={styles.page}>
        <div className={styles.empty}>
          <div className={styles.emptyIcon}>
            <Icons type={ICONS.MUSIC} />
          </div>
          <p className={styles.emptyTitle}>No songs playing</p>
          <p className={styles.emptyText}>Pick a playlist to start listening</p>
          <button className={styles.emptyBtn} onClick={() => navigate("/mobile/playlists")}>Browse Playlists</button>
        </div>
      </div>
    );
  }

  const currentSong = searchedSong || playerSongs?.[currentSongIndex];

  return (
    <div className={styles.page}>
      <div className={styles.stickyHero}>
        <div className={styles.hero}>
          <div className={styles.heroArt}>
            <ThumbNail
              name={playList ? currentPlayList.name : currentSong?.title}
              color={playList ? currentPlayList.color : currentSong?.color}
              hasImage={playList ? !!currentPlayList?.image : !!currentSong?.imageFileName}
              imgSrc={playList ? `${MEDIA_URL}/playlist_images/${currentPlayList?.image}` : `${MEDIA_URL}/songs_images/${currentSong?.imageFileName}`}
              imageFileName={playList ? currentPlayList?.image : currentSong?.imageFileName}
            />
          </div>
          <div className={styles.heroInfo}>
            <p className={styles.heroTitle}>{currentSong?.title}</p>
            <p className={styles.heroArtist}>{currentSong?.artist}</p>
            {currentPlayList?.name && <p className={styles.heroPlaylist}>{currentPlayList.name}</p>}
          </div>
        </div>
        <div className={styles.heroDivider} />
      </div>
      <MobileSongList songs={playerSongs} onSongClick={handleSongClick} onLikeClick={handleLikeClick} />
    </div>
  );
};

export default MobileHome;
